import { get, post } from './apiClient';

export function fetchDashboard() {
  return get('/api/dashboard');
}

export function fetchMe() {
  return get('/api/me');
}

export function fetchMediaLibrary(path = '') {
  return get(`/api/media/library?path=${encodeURIComponent(path)}`);
}

export function fetchPresignedUrl(assetId, action = 'preview') {
  return get(`/api/media/${assetId}/presigned-url?action=${action}`);
}

export function presignS3Key(key, action = 'preview') {
  return post('/api/media/presign', { key, action });
}

export function searchMedia(query) {
  return get(`/api/media/search?query=${encodeURIComponent(query)}`);
}

export function deleteFiles(keys) {
  return post('/api/media/delete', { keys });
}
